import * as PIXI from "pixi.js";
import Game from "../../../Game";
import Layers from "../../../layers/Layers";
import { Coord } from "../../../types/Interface";


const defaultSize = {
  width: 200,
  height: 100
}


export default class ModalRenderer extends PIXI.Container {
  private Game = Game.getInstance();
  private dim = this.Game.getDim();
  private Layers = Layers.getInstance();
  private overlay = this.addChild(new PIXI.Graphics());
  wrapper = this.addChild(new PIXI.Container());
  private modalBg = this.wrapper.addChild(new PIXI.Graphics());
  private coord = { x: this.dim.WIDTH / 2, y: this.dim.HEIGHT / 2 };

  constructor(coord: Coord, private sizes: PIXI.Size = defaultSize, hideoverlay: boolean = false) {
    super();
    coord ? this.coord = coord : "";
    this.drawOverlay(hideoverlay ? 0 : .3);
    this.drawModal();

    this.setCoord();
    this.deactivateEventMode();
    this.addToLayer();
    this.visible = false;
  }
  private addToLayer = () => this.Layers.UITop.addChild(this);
  private setCoord = () => this.position.copyFrom(this.coord);
  getDeactiveElms = () => [this.overlay, this.modalBg];
  private deactivateEventMode = () => this.getDeactiveElms().forEach(e => e.eventMode = "none");
  private drawOverlay(alpha: number = .3) {
    this.overlay
      .rect(- this.coord.x, -this.coord.y, this.dim.WIDTH, this.dim.HEIGHT)
      .fill({ color: 0x000000, alpha });
  }
  private drawModal() {
    this.modalBg
      .roundRect(-this.sizes.width / 2, -this.sizes.height / 2, this.sizes.width, this.sizes.height, 10)
      .fill(0xFFFFFF);
  }
}